import React, { useLayoutEffect, useRef } from 'react';

export const useUniformRuleBadgeWidth = (active) => {
  const ref = useRef(null);
  useLayoutEffect(() => {
    const element = ref.current;
    if (!active || !element) return undefined;
    let frame;
    const measure = () => {
      const widths = Array.from(element.querySelectorAll('[data-rule-badge-label]'),
        (label) => label.getBoundingClientRect().width);
      const width = Math.ceil(Math.max(0, ...widths)) + 22;
      element.style.setProperty('--rule-badge-width', `${width}px`);
    };
    const schedule = () => {
      cancelAnimationFrame(frame);
      frame = requestAnimationFrame(measure);
    };
    const observer = new MutationObserver(schedule);
    observer.observe(element, { childList: true, characterData: true, subtree: true });
    window.addEventListener('resize', schedule);
    document.fonts?.addEventListener('loadingdone', schedule);
    measure();
    return () => {
      observer.disconnect();
      cancelAnimationFrame(frame);
      window.removeEventListener('resize', schedule);
      document.fonts?.removeEventListener('loadingdone', schedule);
    };
  }, [active]);
  return ref;
};

const QuickPriceRuleBadge = ({ children, tone = 'blue', title, ...props }) => (
  <span {...props} title={title || children}
    className={`inline-flex h-7 max-w-full items-center justify-center overflow-hidden rounded-full border px-2.5 text-[11px] font-semibold leading-4 ${tone === 'violet'
      ? 'border-violet-300 bg-white/80 text-violet-800'
      : 'border-blue-300 bg-white/80 text-blue-800'}`}
    style={{ width: 'var(--rule-badge-width, max-content)' }}>
    <span data-rule-badge-label className="inline-block shrink-0 whitespace-nowrap">{children}</span>
  </span>
);

export default QuickPriceRuleBadge;
